import React, { Component } from 'react';
import { DropdownButton, MenuItem} from 'react-bootstrap';
import './SortButton.css';

class SortButton extends Component {
  constructor(props) {
    super(props);
    // TODO: Add a new key/value pair in the state to keep track of type
    this.state = {
      title: "Sort By"
    };
  }

  changeOption = (option, action) => {
    return () => {
      this.setState({
        title: option.name
      });
      action();
    }
  }

  renderOptions() {
    return this.props.sorters.map(option => {
      return <MenuItem key={option.key} eventKey={option.key} onSelect={this.changeOption(option, this.props.action(option))}>{option.name}</MenuItem>
    });
  }

  render() {
    return (
      <DropdownButton id="sort" title={this.state.title}>
        {this.renderOptions()}
      </DropdownButton>
    );
  }
}

export default SortButton;


// WEBPACK FOOTER //
// ./src/SortButton.jsx